import { Container, Grid } from "@material-ui/core";
import dayjs from "dayjs";
import { Fragment, useState } from "react";

import Countdown from "react-countdown";
import MiniLogo from "../../assets/mini-logo.png";
// import Box from "../../assets/box.jpg";
import "./index.less";

const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
  const times = [
    {
      uint: "Days",
      value: days,
    },
    {
      uint: "Hours",
      value: hours,
    },
    {
      uint: "Minutes",
      value: minutes,
    },
    {
      uint: "Seconds",
      value: seconds,
    },
  ];
  // if (completed) {
  //   return <div>finish</div>;
  // } else {
  return (
    <div className="count">
      <Grid container className="unit-container" wrap="nowrap">
        {times.map((t, index) => {
          return (
            <Fragment key={index}>
              <Grid item xs={3} key={t.uint}>
                <div className="uint-text">{t.uint}</div>
                <div className="count-text">
                  {/* <div className="punc">:</div> */}
                  <div className="value">
                    {t.uint !== "Days" && t.value < 10
                      ? `0${t.value}`
                      : t.value}
                  </div>
                </div>
              </Grid>
              {index !== 3 && (
                <Grid item xs={1} className="punc">
                  <div style={{ marginBottom: "1.33vw" }}>:</div>
                </Grid>
              )}
            </Fragment>
          );
        })}
      </Grid>
    </div>
  );
  // }
};

export default function CountDown({
  children,
  date,
  isGame,
  isGallery,
}: {
  children?: JSX.Element;
  isGame?: boolean;
  isGallery?: boolean;
  date: number;
}) {
  const [completed, setCompleted] = useState(false);

  if ((completed && children) || (dayjs().isAfter(date) && children)) {
    return children;
  }

  return (
    <div className="count-down">
      <Container maxWidth="lg" className="count-down-container">
        <Grid item xs={12}>
          <Grid container direction="column" alignItems="center">
            <Grid item xs={8} md={3}>
              <img src={MiniLogo} width="100%" alt="" />
            </Grid>
            <Grid item xs={8} xl={12} className="coming">
              COMING SOON
            </Grid>
            {isGame ? (
              <div style={{ marginTop: "30px" }}>
                Treasure Hunt Game will activate shortly after 30% of KungFu
                Heroes are sold.
              </div>
            ) : isGallery ? (
              <div style={{ marginTop: "30px" }}>
                Gallery will be available after the reveal.
              </div>
            ) : (
              <Grid item xs={8} md={12} className="count-container">
                <Countdown
                  date={date}
                  renderer={renderer}
                  onComplete={() => {
                    setCompleted(true);
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
